export const SELECTION_ACTION_BAR_ID = 'selection-action-bar';
export const SELECTION_BAR_ANIMATION_SECONDS = 0.15;
export const SELECTION_BAR_DELAY = 150;
